function sha256(data) {
    let h0 = 0x6a09e667, h1 = 0xbb67ae85, h2 = 0x3c6ef372, h3 = 0xa54ff53a,
        h4 = 0x510e527f, h5 = 0x9b05688c, h6 = 0x1f83d9ab, h7 = 0x5be0cd19,
        tsz = 0, bp = 0;
    const k = [0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
               0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
               0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
               0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
               0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
               0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
               0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
               0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208, 0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2],
          rrot = (x, n) => (x >>> n) | (x << (32-n)),
          w = new Uint32Array(64),
          buf = new Uint8Array(64),
          process = () => {
              for (let j=0,r=0; j<16; j++,r+=4) {
                  w[j] = (buf[r]<<24) | (buf[r+1]<<16) | (buf[r+2]<<8) | buf[r+3];
              }
              for (let j=16; j<64; j++) {
                  let s0 = rrot(w[j-15], 7) ^ rrot(w[j-15], 18) ^ (w[j-15] >>> 3);
                  let s1 = rrot(w[j-2], 17) ^ rrot(w[j-2], 19) ^ (w[j-2] >>> 10);
                  w[j] = (w[j-16] + s0 + w[j-7] + s1) | 0;
              }
              let a = h0, b = h1, c = h2, d = h3, e = h4, f = h5, g = h6, h = h7;
              for (let j=0; j<64; j++) {
                  let S1 = rrot(e, 6) ^ rrot(e, 11) ^ rrot(e, 25),
                      ch = (e & f) ^ ((~e) & g),
                      t1 = (h + S1 + ch + k[j] + w[j]) | 0,
                      S0 = rrot(a, 2) ^ rrot(a, 13) ^ rrot(a, 22),
                      maj = (a & b) ^ (a & c) ^ (b & c),
                      t2 = (S0 + maj) | 0;
                  h = g; g = f; f = e; e = (d + t1)|0; d = c; c = b; b = a; a = (t1 + t2)|0;
              }
              h0 = (h0 + a)|0; h1 = (h1 + b)|0; h2 = (h2 + c)|0; h3 = (h3 + d)|0;
              h4 = (h4 + e)|0; h5 = (h5 + f)|0; h6 = (h6 + g)|0; h7 = (h7 + h)|0;
              bp = 0;
          },
          add = data => {
              if (typeof data === "string") {
                  data = typeof TextEncoder === "undefined" ? Buffer.from(data) : (new TextEncoder).encode(data);
              }
              for (let i=0; i<data.length; i++) {
                  buf[bp++] = data[i];
                  if (bp === 64) process();
              }
              tsz += data.length;
          },
          digest = () => {
              buf[bp++] = 0x80; if (bp == 64) process();
              if (bp + 8 > 64) {
                  while (bp < 64) buf[bp++] = 0x00;
                  process();
              }
              while (bp < 58) buf[bp++] = 0x00;
              // Max number of bytes is 35,184,372,088,831
              let L = tsz * 8;
              buf[bp++] = (L / 1099511627776.) & 255;
              buf[bp++] = (L / 4294967296.) & 255;
              buf[bp++] = L >>> 24;
              buf[bp++] = (L >>> 16) & 255;
              buf[bp++] = (L >>> 8) & 255;
              buf[bp++] = L & 255;
              process();
              let reply = new Uint8Array(32);
              reply[ 0] = h0 >>> 24; reply[ 1] = (h0 >>> 16) & 255; reply[ 2] = (h0 >>> 8) & 255; reply[ 3] = h0 & 255;
              reply[ 4] = h1 >>> 24; reply[ 5] = (h1 >>> 16) & 255; reply[ 6] = (h1 >>> 8) & 255; reply[ 7] = h1 & 255;
              reply[ 8] = h2 >>> 24; reply[ 9] = (h2 >>> 16) & 255; reply[10] = (h2 >>> 8) & 255; reply[11] = h2 & 255;
              reply[12] = h3 >>> 24; reply[13] = (h3 >>> 16) & 255; reply[14] = (h3 >>> 8) & 255; reply[15] = h3 & 255;
              reply[16] = h4 >>> 24; reply[17] = (h4 >>> 16) & 255; reply[18] = (h4 >>> 8) & 255; reply[19] = h4 & 255;
              reply[20] = h5 >>> 24; reply[21] = (h5 >>> 16) & 255; reply[22] = (h5 >>> 8) & 255; reply[23] = h5 & 255;
              reply[24] = h6 >>> 24; reply[25] = (h6 >>> 16) & 255; reply[26] = (h6 >>> 8) & 255; reply[27] = h6 & 255;
              reply[28] = h7 >>> 24; reply[29] = (h7 >>> 16) & 255; reply[30] = (h7 >>> 8) & 255; reply[31] = h7 & 255;
              reply.hex = () => {
                  let res = "";
                  reply.forEach(x => res += ("0" + x.toString(16)).slice(-2));
                  return res;
              };
              return reply;
          };
    if (data === undefined) return {add, digest};
    add(data);
    return digest();
}

if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector('.js-product-form');
      if (this.form) {
        this.cartDrawer = document.querySelector('cart-drawer');
        this.submitBtn = this.querySelector('[name="add"]');

        if (theme.settings.afterAtc !== 'no-js') {
          this.form.addEventListener('submit', this.handleSubmit.bind(this));
        }

        this.crosssellItemsAreReady = false;
      }
    }

    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;

      evt.preventDefault();

      if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();

      // Disable "Add to Cart" button until submission is complete.
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');

      const formData = new FormData(this.form);

      // identify where the product is added from
      if (this.form.classList.contains('js-product-form-main')) {
        formData.append('[properties][_AddedFrom]', 'product-template');
      } else {
        formData.append('[properties][_AddedFrom]', 'collection');
      }

      var productId = formData.get('product-id');

      // add to cart from product data object
      this.pdoSubmitButtons = [];
      const pdpProductContentElement = document.getElementById('pdp-product-content');
      const pcElement = document.querySelector('product-card[data-product-id="' + productId + '"]');

      if (pdpProductContentElement) {
        this.pdoSubmitButtons = pdpProductContentElement.querySelectorAll('[name="add"]');
      } else if (pcElement) {
        this.pdoSubmitButtons = pcElement.querySelectorAll('[name="add"]');
      }

      // add to cart from product data object
      if (this.pdoSubmitButtons.length) {
        this.pdoSubmitButtons.forEach(pdoSubmitButton => {
          pdoSubmitButton.setAttribute('aria-disabled', 'true');
          pdoSubmitButton.classList.add('is-loading');
        });
      }

      /* ADD GIFT ITEMS */
      var giftIndex = 0;
      let giftCheckedInputs = [];

      const pdpProductDetailsElement = document.querySelector('#pdp-product-details');
      if (pdpProductDetailsElement) {
        giftCheckedInputs = pdpProductDetailsElement.querySelectorAll('input[name="gift_variant_id"]');
      } else if (pcElement) {
        giftCheckedInputs = pcElement.querySelectorAll('input[name="gift_variant_id"]');
      }

      if (giftCheckedInputs.length) {
        Array.from(giftCheckedInputs).map(function (giftCheckedInput, index) {
          const giftVariantId = giftCheckedInput.value;
          giftIndex = index + 1; // ignore the existed product indexes

          const giftAtcElement = giftCheckedInput.closest('.atc');

          formData.append('items[' + giftIndex + '][id]', giftVariantId);

          var giftQuantity = 1;
          if (giftAtcElement) {
            const quantityInput = giftAtcElement.querySelector('input[name="quantity"]');
            if (quantityInput) {
              giftQuantity = quantityInput.value;
            }
          }
          formData.append('items[' + giftIndex + '][quantity]', giftQuantity);

          if (giftAtcElement) {
            const savePercentageInput = giftAtcElement.querySelector('input[name="save_percentage"]');
            if (savePercentageInput) {
              const savePercentage = savePercentageInput.value;
              formData.append('items[' + giftIndex + '][properties][_du]', savePercentage);

              const hash = sha256("gid://shopify/ProductVariant/" + giftVariantId + "," + savePercentage).hex();
              formData.append('items[' + giftIndex + '][properties][_dh]', hash);
            }
          }

          formData.append('items[' + giftIndex + '][properties][_AddedFrom]', 'upsell-gift');

          if (giftAtcElement) {
            const selectedVariantSkuInput = giftAtcElement.querySelector('input[name="selected_variant_sku"]');
            if (selectedVariantSkuInput) {
              const selectedVariantSku = selectedVariantSkuInput.value;
              formData.append('items[' + giftIndex + '][properties][_sku]', selectedVariantSku);
            }
          }

          formData.append('items[' + giftIndex + '][properties][_discount_parent]', formData.get('id'));
          formData.append('items[' + giftIndex + '][properties][_variant_id_parent]', formData.get('id'));
          formData.append('items[' + giftIndex + '][properties][_discount_quantity]', giftQuantity);
          formData.append('items[' + giftIndex + '][properties][_type_free_product]', 'free gift');

          // add gift bundle items
          if (giftAtcElement) {
            let giftIsAllChildsPrepacked = true;
            var giftBundleProductIds = []
            var giftBundleTitles = [];
            var giftBundleVariantIds = [];
            var giftBundleStockProperties = [];
            var giftBundleItemsText = 'Bundle items';

            const giftBundleDataScriptElement = giftAtcElement.querySelector('script[type="application/json"][data-bundle-json]');
            if (giftBundleDataScriptElement) {
              if (giftBundleDataScriptElement.dataset.bundleItemsText) {
                giftBundleItemsText = giftBundleDataScriptElement.dataset.bundleItemsText;
              }
              
              const giftBundleDataContent = giftBundleDataScriptElement.textContent;
              if (giftBundleDataContent) {
                const giftBundleData = JSON.parse(giftBundleDataContent);
                giftBundleData.map(function (giftBundleItem) {
                  if (!giftBundleItem.isPrepacked) {
                    giftIsAllChildsPrepacked = false;
                  }

                  const giftBundleProducts = giftBundleItem.products;
                  giftBundleProducts.map(function (giftBundleProduct) {
                    giftBundleProductIds.push(giftBundleProduct.id);

                    giftBundleTitles.push(giftBundleProduct.quantity + ' x ' + giftBundleProduct.title);

                    if (!giftBundleItem.isPrepacked) {
                      giftBundleVariantIds.push(giftBundleProduct.quantity + ' x ' + giftBundleProduct.selectedVariantId);
                    }
                  });
                });
              }
            }

            if (giftBundleProductIds.length) {
              //formData.append('items[' + giftIndex + ']properties[_bundle_id]', Math.random().toString(36).substring(2, 15));
              formData.append('items[' + giftIndex + ']properties[_bundle_titles]', giftBundleTitles.join(','));
              formData.append('items[' + giftIndex + ']properties[_bundle_variant_ids]', giftBundleVariantIds.join(','));
              formData.append('items[' + giftIndex + ']properties[_bundle_stock_properties]', '');
              if (giftIsAllChildsPrepacked) {
                formData.append('items[' + giftIndex + ']properties[' + giftBundleItemsText + ']', giftBundleTitles.join(', '));
              }
            }
          }
        });
      }
      /* end ADD GIFT ITEMS */

      /* ADD BUNDLE ITEMS */
      let isAllChildsPrepacked = true;
      var bundleProductIds = [];
      var bundleTitles = [];
      var bundleVariantIds = [];
      var bundleStockProperties = [];

      var bundleItemsText = 'Bundle items';
      const bundleDataScriptElement = document.querySelector('script[type="application/json"][data-bundle-json][data-product-id="' + productId + '"]');
      if (bundleDataScriptElement) {
        if (bundleDataScriptElement.dataset.bundleItemsText) {
          bundleItemsText = bundleDataScriptElement.dataset.bundleItemsText;
        }
        
        const bundleDataContent = bundleDataScriptElement.textContent;
        if (bundleDataContent) {
          const bundleData = JSON.parse(bundleDataContent);
          bundleData.map(function (bundleItem) {
            if (!bundleItem.isPrepacked) {
              isAllChildsPrepacked = false;
            }

            const bundleProducts = bundleItem.products;
            bundleProducts.map(function (bundleProduct) {
              bundleProductIds.push(bundleProduct.id);

              bundleTitles.push(bundleProduct.quantity + ' x ' + bundleProduct.title);

              if (!bundleItem.isPrepacked) {
                bundleVariantIds.push(bundleProduct.quantity + ' x ' + bundleProduct.selectedVariantId);
              }
            });
          });
        }
      }

      if (bundleProductIds.length) {
        //formData.append('properties[_bundle_id]', Math.random().toString(36).substring(2, 15));
        formData.append('properties[_bundle_titles]', bundleTitles.join(','));
        formData.append('properties[_bundle_variant_ids]', bundleVariantIds.join(','));
        formData.append('properties[_bundle_stock_properties]', '');
        if (isAllChildsPrepacked) {
          formData.append('properties[' + bundleItemsText + ']', bundleTitles.join(', '));
        }
      }
      /* end ADD BUNDLE ITEMS */

      /* ADD UPSELL ITEMS */
      const upsellCheckedInputs = document.querySelectorAll('input[name="upsell_variant_id"]:checked');
      if (upsellCheckedInputs.length) {
        Array.from(upsellCheckedInputs).map(function (upsellCheckedInput, index) {
          const upsellVariantId = upsellCheckedInput.value;
          var upsellQuantity = 1;
          const upsellIndex = giftIndex + index + 1; // ignore the existed product indexes

          formData.append('items[' + upsellIndex + '][id]', upsellVariantId);
          
          const upsellAtcElement = upsellCheckedInput.closest('.info');
          
          if (upsellAtcElement) {
            const quantityInput = upsellAtcElement.querySelector('input[name="quantity"]');
            if (quantityInput) {
              upsellQuantity = quantityInput.value;
            }

            const savePercentageInput = upsellAtcElement.querySelector('input[name="save_percentage"]');
            if (savePercentageInput) {
              const savePercentage = savePercentageInput.value;
              formData.append('items[' + upsellIndex + '][properties][_du]', savePercentage);

              const hash = sha256("gid://shopify/ProductVariant/" + upsellVariantId + "," + savePercentage).hex();
              formData.append('items[' + upsellIndex + '][properties][_dh]', hash);
            }
          }

          formData.append('items[' + upsellIndex + '][quantity]', upsellQuantity);

          formData.append('items[' + upsellIndex + '][properties][_AddedFrom]', 'upsell');

          if (upsellAtcElement) {
            const selectedVariantSkuInput = upsellAtcElement.querySelector('input[name="selected_variant_sku"]');
            if (selectedVariantSkuInput) {
              const selectedVariantSku = selectedVariantSkuInput.value;
              formData.append('items[' + upsellIndex + '][properties][_sku]', selectedVariantSku);
            }
          }

          formData.append('items[' + upsellIndex + '][properties][_discount_parent]', formData.get('id'));
          formData.append('items[' + upsellIndex + '][properties][_variant_id_parent]', formData.get('id'));
          formData.append('items[' + upsellIndex + '][properties][_discount_quantity]', upsellQuantity);

          // add upsell bundle items
          if (upsellAtcElement) {
            let upsellIsAllChildsPrepacked = true;
            var upsellBundleProductIds = []
            var upsellBundleTitles = [];
            var upsellBundleVariantIds = [];
            var upsellBundleStockProperties = [];
            var upsellBundleItemsText = 'Bundle items';

            const upsellBundleDataScriptElement = upsellAtcElement.querySelector('script[type="application/json"][data-bundle-json]');
            if (upsellBundleDataScriptElement) {
              if (upsellBundleDataScriptElement.dataset.bundleItemsText) {
                upsellBundleItemsText = upsellBundleDataScriptElement.dataset.bundleItemsText;
              }
              
              const upsellBundleDataContent = upsellBundleDataScriptElement.textContent;
              if (upsellBundleDataContent) {
                const upsellBundleData = JSON.parse(upsellBundleDataContent);
                upsellBundleData.map(function (upsellBundleItem) {
                  if (!upsellBundleItem.isPrepacked) {
                    upsellIsAllChildsPrepacked = false;
                  }

                  const upsellBundleProducts = upsellBundleItem.products;
                  upsellBundleProducts.map(function (upsellBundleProduct) {
                    upsellBundleProductIds.push(upsellBundleProduct.id);

                    upsellBundleTitles.push(upsellBundleProduct.quantity + ' x ' + upsellBundleProduct.title);

                    if (!upsellBundleItem.isPrepacked) {
                      upsellBundleVariantIds.push(upsellBundleProduct.quantity + ' x ' + upsellBundleProduct.selectedVariantId);
                    }
                  });
                });
              }
            }

            if (upsellBundleProductIds.length) {
              //formData.append('items[' + upsellIndex + ']properties[_bundle_id]', Math.random().toString(36).substring(2, 15));
              formData.append('items[' + upsellIndex + ']properties[_bundle_titles]', upsellBundleTitles.join(','));
              formData.append('items[' + upsellIndex + ']properties[_bundle_variant_ids]', upsellBundleVariantIds.join(','));
              formData.append('items[' + upsellIndex + ']properties[_bundle_stock_properties]', '');
              if (upsellIsAllChildsPrepacked) {
                formData.append('items[' + upsellIndex + ']properties[' + upsellBundleItemsText + ']', upsellBundleTitles.join(', '));
              }
            }
          }
        });
      }
      /* end ADD UPSELL ITEMS */
      
      /* PREPARE FOR ADDING CROSSSELL ITEMS */
      // do not open cart drawer if there is any crosssell item
      var openCartDrawer = true;
      var openCrosssellItemsModal = false;

      const crosssellItemsModalElement = document.querySelector('#crosssellItemsModal-' + productId);
      if (crosssellItemsModalElement) {
        const crosssellAtcFormElements = crosssellItemsModalElement.querySelectorAll('.crosssell-atc-form');
        if (crosssellAtcFormElements.length) {
          const parentVariantId = formData.get('id');
          
          const _this = this;
          crosssellAtcFormElements.forEach(function (crosssellAtcFormElement, index) {
            const parentVariantIdInputElement = crosssellAtcFormElement.querySelector('input[name="parent_variant_id"]');
            if (parentVariantIdInputElement) {
              parentVariantIdInputElement.value = parentVariantId;
            }

            const discountParentIdInputElement = crosssellAtcFormElement.querySelector('input[name="discount_parent_id"]');
            if (discountParentIdInputElement) {
              discountParentIdInputElement.value = parentVariantId;
            }

            crosssellAtcFormElement.classList.remove('hidden');

            crosssellAtcFormElement.addEventListener('submit', function(e) {
              e.preventDefault();

              var crosssellVariantId = '';
              const crosssellVariantIdInput = crosssellAtcFormElement.querySelector('input[name="crosssell_variant_id"]');
              if (crosssellVariantIdInput) {
                crosssellVariantId = crosssellVariantIdInput.value;
              }

              if (crosssellVariantId) {
                var quantity = 1;
                const quantityInput = crosssellAtcFormElement.querySelector('input[name="quantity"]');
                if (quantityInput) {
                  quantity = quantityInput.value;
                }

                var crosssellFormData = new FormData();
                crosssellFormData.append('items[' + index + '][id]', crosssellVariantId);
                crosssellFormData.append('items[' + index + '][quantity]', quantity);

                crosssellFormData.append('items[' + index + '][properties][_AddedFrom]', 'cross-sell');

                const savePercentageInput = crosssellAtcFormElement.querySelector('input[name="save_percentage"]');
                if (savePercentageInput) {
                  const savePercentage = savePercentageInput.value;
                  crosssellFormData.append('items[' + index + '][properties][_du]', savePercentage);

                  const hash = sha256("gid://shopify/ProductVariant/" + crosssellVariantId + "," + savePercentage).hex();
                  crosssellFormData.append('items[' + index + '][properties][_dh]', hash);
                }

                crosssellFormData.append('items[' + index + '][properties][_discount_quantity]', quantity);

                const selectedVariantSkuInput = crosssellAtcFormElement.querySelector('input[name="selected_variant_sku"]');
                if (selectedVariantSkuInput) {
                  const selectedVariantSku = selectedVariantSkuInput.value;
                  crosssellFormData.append('items[' + index + '][properties][_sku]', selectedVariantSku);
                }

                const parentVariantIdInput = crosssellAtcFormElement.querySelector('input[name="parent_variant_id"]');
                if (parentVariantIdInput) {
                  const parentVariantId = parentVariantIdInput.value;
                  crosssellFormData.append('items[' + index + '][properties][_variant_id_parent]', parentVariantId);
                }

                const discountParentIdInput = crosssellAtcFormElement.querySelector('input[name="discount_parent_id"]');
                if (discountParentIdInput) {
                  const discountParentId = discountParentIdInput.value;
                  crosssellFormData.append('items[' + index + '][properties][_discount_parent]', discountParentId);
                }

                // add all properties inputs
                const propertiesInputs = crosssellAtcFormElement.querySelectorAll('input[name^="[properties]"]:not(:disabled)');
                propertiesInputs.forEach(input => {
                  const name = input.getAttribute('name');
                  const value = input.value;
                  crosssellFormData.append('items[' + index + ']' + name, value);
                });

                // add crosssell bundle items
                let crosssellIsAllChildsPrepacked = true;
                var crosssellBundleProductIds = []
                var crosssellBundleTitles = [];
                var crosssellBundleVariantIds = [];
                var crosssellBundleStockProperties = [];
                var crosssellBundleItemsText = 'Bundle items';

                const crosssellBundleDataScriptElement = crosssellAtcFormElement.querySelector('script[type="application/json"][data-bundle-json]');
                if (crosssellBundleDataScriptElement) {
                  if (crosssellBundleDataScriptElement.dataset.bundleItemsText) {
                    crosssellBundleItemsText = crosssellBundleDataScriptElement.dataset.bundleItemsText;
                  }
                  
                  const crosssellBundleDataContent = crosssellBundleDataScriptElement.textContent;
                  if (crosssellBundleDataContent) {
                    const crosssellBundleData = JSON.parse(crosssellBundleDataContent);
                    crosssellBundleData.map(function (crosssellBundleItem) {
                      if (!crosssellBundleItem.isPrepacked) {
                        crosssellIsAllChildsPrepacked = false;
                      }

                      const crosssellBundleProducts = crosssellBundleItem.products;
                      crosssellBundleProducts.map(function (crosssellBundleProduct) {
                        crosssellBundleProductIds.push(crosssellBundleProduct.id);

                        crosssellBundleTitles.push(crosssellBundleProduct.quantity + ' x ' + crosssellBundleProduct.title);

                        if (!crosssellBundleItem.isPrepacked) {
                          crosssellBundleVariantIds.push(crosssellBundleProduct.quantity + ' x ' + crosssellBundleProduct.selectedVariantId);
                        }
                      });
                    });
                  }
                }

                if (crosssellBundleProductIds.length) {
                  //crosssellFormData.append('items[' + index + ']properties[_bundle_id]', Math.random().toString(36).substring(2, 15));
                  crosssellFormData.append('items[' + index + ']properties[_bundle_titles]', crosssellBundleTitles.join(','));
                  crosssellFormData.append('items[' + index + ']properties[_bundle_variant_ids]', crosssellBundleVariantIds.join(','));
                  crosssellFormData.append('items[' + index + ']properties[_bundle_stock_properties]', '');
                  if (crosssellIsAllChildsPrepacked) {
                    crosssellFormData.append('items[' + index + ']properties[' + crosssellBundleItemsText + ']', crosssellBundleTitles.join(', '));
                  }
                }

                _this.addToCart(crosssellFormData, false, false, crosssellAtcFormElement);
              }
            });
          }.bind(_this));
        }

        if (crosssellAtcFormElements.length) {
          openCartDrawer = false;
          openCrosssellItemsModal = true;
        }
      }
      /* end PREPARE FOR ADDING CROSSSELL ITEMS */

      /* ADD TO CART */
      this.addToCart(formData, openCartDrawer, openCrosssellItemsModal);
      /* end ADD TO CART */
    }

    async addToCart(formData, openCartDrawer = true, openCrosssellItemsModal = false, formElement = null) {
      const _this = this;

      let sections = 'cart-icon-bubble';
      if (this.cartDrawer) {
        sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }

      formData.append('sections_url', window.location.pathname);
      formData.append('sections', sections);

      const productId = formData.get('product-id');

      // animate submit button
      var submitButtons = [];
      if (formElement) {
        submitButtons = formElement.querySelectorAll('[name="add"]');
        if (submitButtons.length == 0) {
          submitButtons = formElement.querySelectorAll('[name="crosssell_add"]');
        }
      }
      if (submitButtons.length) {
        submitButtons.forEach(submitButton => {
          submitButton.setAttribute('aria-disabled', 'true');
          submitButton.classList.add('is-loading');
        });
      }

      const fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      };

      try {
        const oldCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!oldCartResponse.ok) throw new Error(oldCartResponse.status);
        const oldCartData = await oldCartResponse.json();

        const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
        const data = await response.json();

        let error = typeof data.description === 'string' ? data.description : data.message;
        if (data.errors && typeof data.errors === 'object') {
          error = Object.entries(data.errors).map((item) => item[1].join(', '));
        }

        if (data.status) this.setErrorMsgState(error);

        if (!response.ok) throw new Error(response.status);

        if (theme.settings.afterAtc === 'page') {
          // Allow the tick animation to complete
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        } else {
          // Update cart icon count.
          ProductForm.updateCartIcon(data);

          // If item was added from Quick Add drawer, show "Added to cart" message.
          const quickAddDrawer = this.closest('quick-add-drawer');
          if (quickAddDrawer) quickAddDrawer.addedToCart();

          setTimeout(() => {
            // show/hide cross-sell popup based on the theme settings
            if (window.innerWidth <= 768 && window.theme.settings.enableCrossSellPopupMobile == false) {
              openCrosssellItemsModal = false;
              openCartDrawer = true;
            }
            if (window.innerWidth > 768 && window.theme.settings.enableCrossSellPopupDesktop == false) {
              openCrosssellItemsModal = false;
              openCartDrawer = true;
            }

            var needToOpenCartDrawer = !quickAddDrawer && theme.settings.afterAtc === 'drawer';
            if (openCartDrawer == false) {
              needToOpenCartDrawer = false;
            }

            // Update cart drawer contents.
            if (this.cartDrawer) {
              // reload cart drawer content
              this.cartDrawer.renderContents(
                data,
                needToOpenCartDrawer
              );

              // open the crosssell product list
              if (openCrosssellItemsModal) {
                const crosssellItemsModalId = 'crosssellItemsModal-' + productId;
                const crosssellItemsModalElement = document.getElementById(crosssellItemsModalId);
                if (crosssellItemsModalElement) {
                  crosssellItemsModalElement.style.display = 'block';
                  crosssellItemsModalElement.offsetWidth;
                  crosssellItemsModalElement.classList.add('show');
                  document.body.classList.add('modal-open');

                  // open cart drawer on closing popup
                  const crosssellCloseButtons = crosssellItemsModalElement.querySelectorAll('.close, .close-modal-btn');
                  if (crosssellCloseButtons.length) {
                    crosssellCloseButtons.forEach(crosssellCloseButton => {
                      crosssellCloseButton.addEventListener('click', function() {
                        crosssellItemsModalElement.classList.remove('show');
                        document.body.classList.remove('modal-open');

                        const transitionEndHandler = function() {
                          crosssellItemsModalElement.style.display = 'none';
                          crosssellItemsModalElement.removeEventListener('transitionend', transitionEndHandler);
                        };
                        crosssellItemsModalElement.addEventListener('transitionend', transitionEndHandler);

                        _this.cartDrawer.open();
                      }.bind(_this));
                    });
                  }

                  crosssellItemsModalElement.addEventListener('click', function(event) {
                    if (event.target === crosssellItemsModalElement) {
                      _this.cartDrawer.open();
                    }
                  }.bind(_this));
                }
              }
            } else if (window.location.pathname === theme.routes.cart) {
              const cartItems = document.querySelector('cart-items');
              if (cartItems) {
                if (cartItems.dataset.empty === 'true') {
                  window.location.reload();
                } else {
                  cartItems.refresh();
                }
              }
            }
          }, 700);
        }

        const newCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!newCartResponse.ok) throw new Error(newCartResponse.status);
        const newCartData = await newCartResponse.json();
        const itemInOldCart = oldCartData.items.filter(
          (item) => item.variant_id === data.variant_id
        )[0];

        // Check if product was already in the cart
        if (itemInOldCart) {
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id,
              oldQuantity: itemInOldCart.quantity,
              newQuantity: (itemInOldCart.quantity === data.quantity)
                ? itemInOldCart.quantity : data.quantity
            }
          }));
        } else {
          this.dispatchEvent(new CustomEvent('on:cart:add', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id
            }
          }));
        }
      } catch (error) {
        console.log(error); // eslint-disable-line
        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: this.errorMsg?.textContent
          }
        }));

        if (this.cartDrawer) this.cartDrawer.refresh(true);
      } finally {
        // Re-enable 'Add to Cart' button.
        this.submitBtn.classList.add('is-success');
        this.submitBtn.removeAttribute('aria-disabled');
        setTimeout(() => {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.classList.remove('is-success');
        }, 1400);

        // add to cart from product data object
        if (typeof this.pdoSubmitButtons !== 'undefined' && this.pdoSubmitButtons.length) {
          this.pdoSubmitButtons.forEach(pdoSubmitButton => {
            pdoSubmitButton.classList.add('is-success');
            pdoSubmitButton.removeAttribute('aria-disabled');
            setTimeout(() => {
              pdoSubmitButton.classList.remove('is-loading');
              pdoSubmitButton.classList.remove('is-success');
            }, 1400);
          });
        }

        // animate the submit button
        if (submitButtons.length) {
          submitButtons.forEach(submitButton => {
            submitButton.classList.add('is-success');
            submitButton.removeAttribute('aria-disabled');
            setTimeout(() => {
              submitButton.classList.remove('is-loading');
              submitButton.classList.remove('is-success');
            }, 1400);
          });
        }
      }
    }

    /**
     * Updates the cart icon count in the header.
     * @param {object} response - Response JSON.
     */
    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
      }
    }

    /**
     * Shows/hides an error message.
     * @param {string} [error=false] - Error to show a message for.
     */
    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) {
        this.errorMsg.innerHTML = '';
        const errorArray = Array.isArray(error) ? error : [error];
        errorArray.forEach((err, index) => {
          if (index > 0) this.errorMsg.insertAdjacentHTML('beforeend', '<br>');
          this.errorMsg.insertAdjacentText('beforeend', err);
        });
      }
    }
  }

  customElements.define('product-form', ProductForm);
}
